/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddDisciplineSubgroupDTO,
    AddDisciplineSubgroupDTOFromJSON,
    AddDisciplineSubgroupDTOToJSON,
    DisciplineSubgroupDTO,
    DisciplineSubgroupDTOFromJSON,
    DisciplineSubgroupDTOToJSON,
    DisciplineSubgroupGetAllDTOPagedResponse,
    DisciplineSubgroupGetAllDTOPagedResponseFromJSON,
    DisciplineSubgroupGetAllDTOPagedResponseToJSON,
    EditDisciplineSubgroupDTO,
    EditDisciplineSubgroupDTOFromJSON,
    EditDisciplineSubgroupDTOToJSON,
} from '../models';

export interface ApiDisciplineSubgroupAddDisciplineSubgroupPostRequest {
    addDisciplineSubgroupDTO?: AddDisciplineSubgroupDTO;
}

export interface ApiDisciplineSubgroupDeleteIdDeleteRequest {
    id: string;
}

export interface ApiDisciplineSubgroupGetAllDisciplineSubgroupsGetRequest {
    namePattern?: string;
    groupId?: string;
    page?: number;
    pageSize?: number;
}

export interface ApiDisciplineSubgroupGetDisciplineSubgroupByIdIdGetRequest {
    id: string;
}

export interface ApiDisciplineSubgroupUpdateDisciplineSubgroupIdPutRequest {
    id: string;
    editDisciplineSubgroupDTO?: EditDisciplineSubgroupDTO;
}

/**
 * 
 */
export class DisciplineSubgroupApi extends runtime.BaseAPI {

    /**
     */
    async apiDisciplineSubgroupAddDisciplineSubgroupPostRaw(requestParameters: ApiDisciplineSubgroupAddDisciplineSubgroupPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineSubgroup/AddDisciplineSubgroup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDisciplineSubgroupDTOToJSON(requestParameters.addDisciplineSubgroupDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineSubgroupAddDisciplineSubgroupPost(requestParameters: ApiDisciplineSubgroupAddDisciplineSubgroupPostRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineSubgroupAddDisciplineSubgroupPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDisciplineSubgroupDeleteIdDeleteRaw(requestParameters: ApiDisciplineSubgroupDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineSubgroupDeleteIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineSubgroup/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineSubgroupDeleteIdDelete(requestParameters: ApiDisciplineSubgroupDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineSubgroupDeleteIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDisciplineSubgroupGetAllDisciplineSubgroupsGetRaw(requestParameters: ApiDisciplineSubgroupGetAllDisciplineSubgroupsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DisciplineSubgroupGetAllDTOPagedResponse>> {
        const queryParameters: any = {};

        if (requestParameters.namePattern !== undefined) {
            queryParameters['NamePattern'] = requestParameters.namePattern;
        }

        if (requestParameters.groupId !== undefined) {
            queryParameters['GroupId'] = requestParameters.groupId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['PageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineSubgroup/GetAllDisciplineSubgroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisciplineSubgroupGetAllDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDisciplineSubgroupGetAllDisciplineSubgroupsGet(requestParameters: ApiDisciplineSubgroupGetAllDisciplineSubgroupsGetRequest = {}, initOverrides?: RequestInit): Promise<DisciplineSubgroupGetAllDTOPagedResponse> {
        const response = await this.apiDisciplineSubgroupGetAllDisciplineSubgroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDisciplineSubgroupGetDisciplineSubgroupByIdIdGetRaw(requestParameters: ApiDisciplineSubgroupGetDisciplineSubgroupByIdIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DisciplineSubgroupDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineSubgroupGetDisciplineSubgroupByIdIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineSubgroup/GetDisciplineSubgroupById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisciplineSubgroupDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiDisciplineSubgroupGetDisciplineSubgroupByIdIdGet(requestParameters: ApiDisciplineSubgroupGetDisciplineSubgroupByIdIdGetRequest, initOverrides?: RequestInit): Promise<DisciplineSubgroupDTO> {
        const response = await this.apiDisciplineSubgroupGetDisciplineSubgroupByIdIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDisciplineSubgroupUpdateDisciplineSubgroupIdPutRaw(requestParameters: ApiDisciplineSubgroupUpdateDisciplineSubgroupIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineSubgroupUpdateDisciplineSubgroupIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineSubgroup/UpdateDisciplineSubgroup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EditDisciplineSubgroupDTOToJSON(requestParameters.editDisciplineSubgroupDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineSubgroupUpdateDisciplineSubgroupIdPut(requestParameters: ApiDisciplineSubgroupUpdateDisciplineSubgroupIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineSubgroupUpdateDisciplineSubgroupIdPutRaw(requestParameters, initOverrides);
    }

}
